const trimChars = (str, c) => {
  var re = new RegExp('^[' + c + ']+|[' + c + ']+$', 'g');
  return str.replace(re, '');
};

export default trimChars;
